module.exports = __webpack_public_path__ + "img/螺旋塔.fa43b03d.png";